/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateExperimentResponse
 */
export interface CreateExperimentResponse {
  /**
   *
   * @type {string}
   * @memberof CreateExperimentResponse
   */
  experimentId: string;
}

/**
 * Check if a given object implements the CreateExperimentResponse interface.
 */
export function instanceOfCreateExperimentResponse(
  value: object,
): value is CreateExperimentResponse {
  if (!("experimentId" in value) || value["experimentId"] === undefined)
    return false;
  return true;
}

export function CreateExperimentResponseFromJSON(
  json: any,
): CreateExperimentResponse {
  return CreateExperimentResponseFromJSONTyped(json, false);
}

export function CreateExperimentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateExperimentResponse {
  if (json == null) {
    return json;
  }
  return {
    experimentId: json["experimentId"],
  };
}

export function CreateExperimentResponseToJSON(
  json: any,
): CreateExperimentResponse {
  return CreateExperimentResponseToJSONTyped(json, false);
}

export function CreateExperimentResponseToJSONTyped(
  value?: CreateExperimentResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    experimentId: value["experimentId"],
  };
}
